module.exports = __webpack_public_path__ + "static/caja_de_cambios_remolcable-7f409ef75c1bf74fb6c50856cd2da50d.png";